export const convertFilesToBase64 = (files: FileList | null) => {
    const filesArray = Array.from(files || []);

    return Promise.all(
        filesArray.map((file: Blob) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            });
        })
    );
};
